const getDialogTitle = (title: string) => `Are you sure you want to leave ${title} facility?`;

export { getDialogTitle };
